export default "__VITE_ASSET__CSEWIJN6__"